import { h } from 'preact';
// @ts-ignore
import { CHROME_EXTENSION_URL } from '../../../constants.js';

export function Footer() {
  return (
    <footer class="site-footer">
      <a href={CHROME_EXTENSION_URL} target="_blank">Chrome extension</a>
      <a href="/pricing">Pricing</a>
      <a href="/privacy">Privacy Policy</a>
      <a href="/terms">Terms of Service</a>
      <span
        class="site-footer-epigraph"
        title="Truth is one; the wise speak of it in many ways. (Ṛgveda 1.164.46)"
      >
        <span class="epigraph-devanagari" lang="sa">एकं सद्विप्रा बहुधा वदन्ति</span>
        <span class="epigraph-source">
          <cite>Ṛgveda</cite> 1.164.46
        </span>
      </span>
    </footer>
  );
}
